<template>
    <div class="modal" id="view-permission-package-modal">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div id="view-permission-package-form" action="" method="POST">
                    <div class="modal-header">
                        <h4>Ver paquete de permisos</h4>
                        <button @click="closeModal" class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label for="view-permission-package-name" class="form-label col-8">Nombre</label>
                        </div>
                        <input type="text" class="form-control" name="name" id="view-permission-package-name" v-model="viewPermissionPackageName" disabled>
                        <div class="row">
                            <label for="view-permission-package-description" class="form-label col-8">Descripción</label>
                        </div>
                        <textarea class="form-control" name="description" id="view-permission-package-description" v-model="viewPermissionPackageDescription" rows="6" disabled></textarea>
                    </div>
                    <div class="modal-footer">
                        <button id="view-permission-package-close" class="col-4 btn btn-danger" type="button" @click="closeModal">
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PermissionPackageViewModal',
    props: {
        viewPermissionPackageName: {
            type: String,
            required: true
        },
        viewPermissionPackageDescription: {
            type: String,
            required: true
        }
    },
    data() {
        return {
        };
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        }
    }
};
</script>